import Welton81 from '../../../Media/BSD/Hiera/Welton 8.webp'
import Welton82 from '../../../Media/BSD/Hiera/Welton 8.webp'





const Welton8images =[
Welton81,Welton82
]

export default Welton8images;